import React, { useState } from 'react';
import { Image } from 'react-native';
import {
  Colors,
  Divider,
  Flex,
  IconChevronRight,
  Typography,
  useScreenSize,
} from '@banhala/ui-kit';

export const WashingGuide: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { width: screenWidth } = useScreenSize();

  return (
    <Flex>
      <Divider size="small" />
      <Flex padding={{ horizontal: 16 }}>
        <Flex.Row
          justifyContent={'space-between'}
          alignItems={'center'}
          padding={{ vertical: 20 }}
          onPress={() => setIsOpen(true)}
        >
          <Typography type={'h5'} color={'content_primary'}>
            WASHING GUIDE
          </Typography>
          {!isOpen && (
            <Flex.Center padding={{ horizontal: 8, vertical: 8 }}>
              <IconChevronRight size={16} color={Colors.content_tertiary} />
            </Flex.Center>
          )}
        </Flex.Row>
      </Flex>
      <Divider size="small" />
      {isOpen && (
        <>
          <Image
            source={require('../assets/img-washing.png')}
            style={{ width: screenWidth, height: screenWidth * (5820 / 1080) }}
            resizeMode="contain"
          />
          <Divider size="small" />
        </>
      )}
    </Flex>
  );
};
